export const whatsappEndpoint = (phone: string, text?: string) => {
	return `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURI(text)}`;
};
